import React, { FC, useMemo } from 'react';
import { createCn } from '../../../helpers/utils';
import classes from '../styles.module.scss';
import { useTranslation } from 'react-i18next';
import { Plus } from '../../../assets';
import { Speaker } from '../speakers.page';
import SpeakerCard from './speaker-card.component';
import { groupSpeakersByDepartment } from '../utils/speaker-ui';

interface IProps {
  items: Speaker[];
  onRefresh: () => void;
  onAddClick: () => void;
  activeId: string | null;
  onActivate: (id: string) => void;
  onDeactivate: () => void;
}

const cn = createCn('speakers', classes);

const SpeakerGrid: FC<IProps> = ({
  items,
  onRefresh,
  onAddClick,
  activeId,
  onActivate,
  onDeactivate,
}) => {
  const { t } = useTranslation();
  const groups = useMemo(() => groupSpeakersByDepartment(items), [items]);

  let cardIndex = 0;

  return (
    <>
      <div className={cn('section-header')}>
        <span className={cn('section-label')}>{t('speakers.all-speakers')}</span>
        <span className={cn('badge')}>
          {items.length} {t('speakers.count-label')}
        </span>
      </div>

      {groups.map(group => (
        <section key={group.key} className={cn('department-section')}>
          <div className={cn('department-header')}>
            <span className={cn('department-title')}>
              {group.key === 'other' ? t('speakers.department-other') : group.label}
            </span>
            <span className={cn('department-count')}>
              {group.items.length} {t('speakers.count-label')}
            </span>
          </div>
          <div className={cn('grid')}>
            {group.items.map(item => {
              const index = cardIndex;
              cardIndex += 1;
              return (
                <SpeakerCard
                  key={item.id}
                  item={item}
                  index={index}
                  onRefresh={onRefresh}
                  activeId={activeId}
                  onActivate={onActivate}
                  onDeactivate={onDeactivate}
                />
              );
            })}
          </div>
        </section>
      ))}

      <div className={cn('grid', { single: true })}>
        <button type="button" className={cn('add-placeholder')} onClick={onAddClick}>
          <Plus />
          <span>{t('speakers.add')}</span>
        </button>
      </div>
    </>
  );
};

export default SpeakerGrid;
